import { useQuery } from "react-query";

import { ITheme } from "../../models/theme/Theme";
import useQSBuilder from "../../hooks/useQSBuilder";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { themeQueryKeys } from "./queryKeys";

export function useThemes(includeInactive = false) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const themes = useQuery({
    queryKey: themeQueryKeys.all(includeInactive),
    queryFn: () =>
      get(
        `/theme${buildQs({ includeInactive })}`
      ) as unknown as IDefaultResponseWithData<ITheme[]>,
    refetchOnWindowFocus: false,
  });

  return {
    themes,
  };
}
